var PromiseifyMiddleware = function PromiseifyMiddleware(_) {
  return function (next) {
    return function (action) {
      next(action);
      return Promise.resolve();
    };
  };
};

export default PromiseifyMiddleware;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9yZWFjdC1pbnRlZ3JhdGlvbi9wcm92aWRlci9Qcm9taXNlaWZ5TWlkZGxld2FyZS50cyJdLCJuYW1lcyI6WyJQcm9taXNlaWZ5TWlkZGxld2FyZSIsIl8iLCJuZXh0IiwiYWN0aW9uIiwiUHJvbWlzZSIsInJlc29sdmUiXSwibWFwcGluZ3MiOiJBQUVBLElBQU1BLG9CQUFvQixHQUFHLFNBQXZCQSxvQkFBdUIsQ0FDM0JDLENBRDJCO0FBQUEsU0FFeEIsVUFBQ0MsSUFBRDtBQUFBLFdBQXVCLFVBQUNDLE1BQUQsRUFBbUQ7QUFDN0VELE1BQUFBLElBQUksQ0FBQ0MsTUFBRCxDQUFKO0FBQ0EsYUFBT0MsT0FBTyxDQUFDQyxPQUFSLEVBQVA7QUFDRCxLQUhJO0FBQUEsR0FGd0I7QUFBQSxDQUE3Qjs7QUFNQSxlQUFlTCxvQkFBZiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IE1pZGRsZXdhcmVBUEksIERpc3BhdGNoIH0gZnJvbSAnfi90eXBlcyc7XG5cbmNvbnN0IFByb21pc2VpZnlNaWRkbGV3YXJlID0gPFIgZXh0ZW5kcyBSZWFjdC5SZWR1Y2VyPGFueSwgYW55Pj4oXG4gIF86IE1pZGRsZXdhcmVBUEk8Uj4sXG4pID0+IChuZXh0OiBEaXNwYXRjaDxSPikgPT4gKGFjdGlvbjogUmVhY3QuUmVkdWNlckFjdGlvbjxSPik6IFByb21pc2U8dm9pZD4gPT4ge1xuICBuZXh0KGFjdGlvbik7XG4gIHJldHVybiBQcm9taXNlLnJlc29sdmUoKTtcbn07XG5leHBvcnQgZGVmYXVsdCBQcm9taXNlaWZ5TWlkZGxld2FyZTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/rest-hooks/lib/react-integration/provider/PromiseifyMiddleware.js
// module id = null
// module chunks = 